module.exports = __webpack_public_path__ + "img/phoneandtab.e18385e6.jpg";